import { api } from './api';

export const VIEW_PAGE_FRAUD0 = 'fraud0_leads';

// Write-list (outreach) thresholds — editable + persisted. min_recoverable_eur null = gate off.
export interface ViewThresholds {
  min_paid_share: number | null;     // 0..1 paid-traffic floor (main write-list gate)
  min_recoverable_eur: number | null;// recoverable ad-fraud €/yr floor; null = off
  min_search_paid_spend?: number | null; // monthly search-paid ad spend € floor; null = off (boss ~30k)
}

// Economics assumptions — editable + persisted. recoverable_rate = clawback fraction (0–0.2).
export interface ViewAssumptions {
  recoverable_rate: number;          // fraction of fraud-channel adspend realistically recoverable
  prevention_eff?: number;           // share of bot/IVT spend fraud0 actually saves (prevention lever, 0–1)
  cpc_eur?: number;                  // search cost-per-click assumption €/click (spend + value estimate)
  value_channels?: string[];         // paid channels that feed the value (default ['search_paid'])
}

// ICP qualify band (real SimilarWeb monthly visits) — global, drives auto-qualify + the scrape planner.
export interface IcpBandConfig {
  qualify_visits_min: number;
  qualify_visits_max: number;
}

export interface ViewConfig {
  page: string;
  columns: Record<string, boolean>;
  actions: Record<string, boolean>;
  filterBar: { visible: boolean };
  instruction: string;
  thresholds: ViewThresholds;
  assumptions: ViewAssumptions;
  icp_band?: IcpBandConfig;
}

export interface ColumnMeta { key: string; label: string; required: boolean }
export interface ActionMeta { key: string; label: string }

export interface ViewConfigRegistry {
  page: string;
  columns: ColumnMeta[];
  actions: ActionMeta[];
  role_defaults: Record<string, Omit<ViewConfig, 'page'>>;
}

export interface StoredViewConfig {
  scope_type: 'role' | 'user';
  scope_value: string;
  config: Partial<Omit<ViewConfig, 'page'>>;
  updated_at: string;
  updated_by: number | null;
}

export const viewConfigApi = {
  getEffective: (page = VIEW_PAGE_FRAUD0) =>
    api.get<ViewConfig>(`/view-config?page=${encodeURIComponent(page)}`),

  listAdmin: (page = VIEW_PAGE_FRAUD0) =>
    api.get<{ registry: ViewConfigRegistry; stored: StoredViewConfig[] }>(
      `/admin/view-configs?page=${encodeURIComponent(page)}`,
    ),

  upsert: (body: {
    scope_type: 'role' | 'user';
    scope_value: string;
    page?: string;
    config: Partial<Omit<ViewConfig, 'page'>>;
  }) => api.put<{ ok: boolean }>(`/admin/view-config`, { page: VIEW_PAGE_FRAUD0, ...body }),
};
